import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authApi = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  register: (data) => api.post('/auth/register', data),
  getMe: () => api.get('/auth/me'),
  changePassword: (data) => api.put('/auth/change-password', data),
  init: () => api.post('/init'),
};

// CTOs
export const ctosApi = {
  getAll: () => api.get('/ctos'),
  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/ctos/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  getUploads: () => api.get('/ctos/uploads'),
  getLastUpdate: () => api.get('/ctos/last-update'),
};

// Queries
export const queriesApi = {
  check: (data) => api.post('/queries/check', data),
  getAll: (params) => api.get('/queries', { params }),
  getStats: () => api.get('/queries/stats'),
};

// Waitlist
export const waitlistApi = {
  add: (data) => api.post('/waitlist', data),
  getAll: () => api.get('/waitlist'),
  delete: (id) => api.delete(`/waitlist/${id}`),
  export: () => api.get('/waitlist/export', { responseType: 'blob' }),
};

// Settings
export const settingsApi = {
  get: () => api.get('/settings'),
  update: (data) => api.put('/settings', data),
};

// Users
export const usersApi = {
  getAll: () => api.get('/users'),
  delete: (id) => api.delete(`/users/${id}`),
  resetPassword: (id, new_password) => api.put(`/users/${id}/password`, { new_password }),
};

// Geocode
export const geocodeApi = {
  search: (q) => api.get('/geocode', { params: { q } }),
};
export default api;
